// Curated fallback content rendered IMMEDIATELY on page load — replaced when the
// live feeds resolve. This guarantees the user never sees a "Loading…" spinner
// or a blank section, even if the Blogger / YouTube feeds are slow or blocked.

export const FALLBACK_POSTS = [
  {
    id: "fallback-partner-remuneration",
    slug: "partner-remuneration-business-income",
    title: "Partner Remuneration is Business Income: Expenses (Including Depreciation) Allowed",
    published: "2025-11-12T00:00:00.000+05:30",
    categories: ["Income Tax", "ITAT"],
    category: "Income Tax",
    excerpt:
      "Delhi ITAT confirms Section 28(v) classification and upholds the consistency rule for partner remuneration treatment.",
    image:
      "https://images.pexels.com/photos/6927546/pexels-photo-6927546.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    link: "https://blog.nrk.info/",
    read_time: "5 min read",
  },
  {
    id: "fallback-gst-itc",
    slug: "gst-itc-eligibility-2025",
    title: "GST Input Tax Credit: Recent Clarifications on Eligibility and Reversal",
    published: "2025-10-28T00:00:00.000+05:30",
    categories: ["GST", "Compliance"],
    category: "GST",
    excerpt:
      "Practical guidance for businesses on documenting and reconciling Input Tax Credit under the latest GST circulars.",
    image:
      "https://images.pexels.com/photos/6863251/pexels-photo-6863251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    link: "https://blog.nrk.info/",
    read_time: "6 min read",
  },
  {
    id: "fallback-tax-audit",
    slug: "tax-audit-fy-2024-25-checklist",
    title: "Tax Audit FY 2024-25: Compliance Checklist for Practitioners",
    published: "2025-09-15T00:00:00.000+05:30",
    categories: ["Income Tax", "Tax Audit"],
    category: "Tax Audit",
    excerpt:
      "Comprehensive checklist covering Form 3CD reporting, Clause 44 disclosures and recent ICAI guidance for the upcoming tax audit season.",
    image:
      "https://images.pexels.com/photos/8867434/pexels-photo-8867434.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    link: "https://blog.nrk.info/",
    read_time: "8 min read",
  },
  {
    id: "fallback-faceless-assessment",
    slug: "faceless-assessment-procedural-safeguards",
    title: "Faceless Assessment: Procedural Safeguards and Recent Judicial Trends",
    published: "2025-08-22T00:00:00.000+05:30",
    categories: ["Income Tax", "Litigation"],
    category: "Litigation",
    excerpt:
      "High Courts continue to emphasise procedural fairness under the faceless assessment regime — a review of recent rulings and best practices.",
    image:
      "https://images.pexels.com/photos/5668857/pexels-photo-5668857.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    link: "https://blog.nrk.info/",
    read_time: "7 min read",
  },
  {
    id: "fallback-msme-compliance",
    slug: "msme-payment-compliance-section-43b-h",
    title: "Section 43B(h): MSME Payment Compliance — Year-End Action Points",
    published: "2025-07-30T00:00:00.000+05:30",
    categories: ["Compliance", "MSME"],
    category: "Compliance",
    excerpt:
      "A practical guide to the 45-day MSME payment rule, its disallowance implications, and reconciliation steps before year-end.",
    image:
      "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    link: "https://blog.nrk.info/",
    read_time: "5 min read",
  },
  {
    id: "fallback-nri-residency",
    slug: "nri-residency-rules-and-fa-disclosures",
    title: "NRI Residency Rules and Schedule FA Disclosures — A Practical Refresher",
    published: "2025-06-18T00:00:00.000+05:30",
    categories: ["NRI Taxation", "Compliance"],
    category: "NRI Taxation",
    excerpt:
      "Examining the residency tests, Schedule FA reporting obligations, and DTAA interplay relevant to globally mobile Indian taxpayers.",
    image:
      "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    link: "https://blog.nrk.info/",
    read_time: "6 min read",
  },
];

// CA. NRK channel — direct iframe-friendly fallback videos. These are real video IDs,
// so even if the YouTube RSS feed is blocked / slow, the iframes render instantly.
const CHANNEL_ID = "UC-uUaiCOqXbPlhtxqPow9sg";
// Uploads playlist follows the rule "UU" + channelId-without-leading-UC
export const CHANNEL_UPLOADS_EMBED = `https://www.youtube.com/embed/videoseries?list=UU${CHANNEL_ID.slice(2)}`;

export const FALLBACK_VIDEOS = [
  {
    id: "wAVy7AjU4no",
    title: "Tax & Compliance Insights — CA. NRK",
    published: "",
    link: "https://www.youtube.com/watch?v=wAVy7AjU4no",
    description: "From the CA. NRK YouTube channel.",
    thumbnail: "https://i.ytimg.com/vi/wAVy7AjU4no/hqdefault.jpg",
    embed_url: "https://www.youtube.com/embed/wAVy7AjU4no",
    views: null,
  },
];
